import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { IconBrandWhatsapp } from '@tabler/icons-react';
import NavbarCategories from './components/Navbarcategories';
import Footer from './components/Footer';

interface ProductCategory {
  m04_category_name: string;
}

interface Product {
  id: string;
  m06_thumbnail_image: string;
  m06_product_sku_name: string;
  m06_description: string;
  productCategories?: ProductCategory[];
  m06_price: number;
  m06_mrp: number;
}

const Allproducts: React.FC = () => {
  const { categoryId } = useParams<{ categoryId: string }>();
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();
  const whatsappNumber = '+971505411910'; // WhatsApp Number for Inquiry

  const handleChange = (id: string) => {
    navigate(`/product/${id}`);
  };

  useEffect(() => {
    // Scroll to the top when the route changes
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);

        const params: Record<string, any> = { page: 1, limit: 20 };
        if (categoryId) {
          params.categoryId = categoryId;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL_CUSTOMER}/product-sku`,
          { params }
        );

        if (response.data?.success) {
          setProducts(response.data.data.products_skus || []);
          setError(null);
        } else {
          throw new Error('Failed to fetch products');
        }
      } catch (error) {
        console.error('Error fetching products:', error);
        setError('Failed to load products. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [categoryId]);

  if (loading) {
    return <p className='min-h-[110vh]'>Loading products...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <>
    <div className="all-products bg-white p-6 relative min-h-[110vh] mt-10">

      {/* {categoryId ? ( */}
        <div className="md:py-5 py-2 relative z-30">
          <NavbarCategories />
        </div>
      {/* ) : ""} */}

      {/* Background Effects */}
      <div className='absolute md:block hidden w-40 h-40 bg-[#bb8624] z-0 rounded-full blur-[80px]'></div>
      <div className='absolute w-40 h-40 right-10 bottom-24 z-0 bg-[#bb8624] rounded-full blur-[80px]'></div>
      <div className='absolute w-40 h-40 right-[50%] top-[40%] z-0 bg-[#bb8624] rounded-full blur-[80px]'></div>
      <div className='absolute md:block hidden w-40 h-40 right-0 top-10 z-10 bg-[#bb8624] rounded-full blur-[80px]'></div>

      {/* Video and Header */}


      {/* Category Name Header */}
      {categoryId && products.length > 0 && (
        <h1 className="col-span-full text-3xl font-semibold text-center text-gray-800 mb-6">
          {products[0]?.productCategories?.[0]?.m04_category_name || 'Category Name'}
        </h1>
      )}

      <div
        className={`grid gap-4 md:gap-8 relative ${categoryId
          ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
          : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
          }`}
      >
        {categoryId && (
          <div className='col-span-1 md:col-span-2 flex justify-center items-center'>
            <iframe
              width="100%"
              height="350"
              src="https://www.youtube.com/embed/ioZmKJG_SME?si=65d4WfODItlOPcTx&autoplay=1&mute=1&loop=1&playlist=ioZmKJG_SME"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="rounded-lg"
            ></iframe>

          </div>
        )}
        {/* Product Cards */}
        {products.map((product) => (
              <div
                key={product.id}
                className="bg-gray-100 rounded-lg overflow-hidden cursor-pointer snap-start transition-transform duration-300 hover:shadow-md"
                onClick={() => navigate(`/product/${product.id}`)}
              >
                {/* Product Card - Matching the design from the image */}
                <div className="p-4 flex flex-col h-full">
                <div className="flex-grow">
                    <h3 className="text-gray-700 font-bold mb-1 truncate">
                      {product.m06_product_sku_name}
                    </h3>
                    <h3 className="text-gray-700 font-medium mb-1 text-[10px] truncate">
                      {product.m06_product_sku_name}
                    </h3>
                    
                    {/* <p className="text-gray-900 font-bold">
                      ${product.m06_price.toFixed(2)}
                    </p> */}
                  </div>
                  <div className="relative  bg-gray-100 rounded-lg pt-4 flex items-center justify-center">
                    <img
                      src={`${process.env.REACT_APP_BACKEND_URL}/${product.m06_thumbnail_image}`}
                      alt={product.m06_product_sku_name}
                      className="w-full h-40 object-contain"
                    />
                    {/* <div className="absolute top-2 right-2">
                      <IconShoppingCart size={20} className="text-gray-700" />
                    </div> */}
                  </div>
                  
              
                </div>
              </div>
            ))}
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default Allproducts;
